/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

// tslint:disable:variable-name

import { ID, WithVersion } from '@gh/common-shared-data';
import { WithOptimisticLock } from '@gh/core-data';
import { isEmpty } from 'lodash';
import { IS_REGION_AU_OR_NZ, IS_REGION_US } from '@gh/common-shared';

export type SiteAddressInfo = {
  lotNumber: string;
  blockNumber: string;
  suburb: string;
  streetNumber: string;
  street: string;
  city: string;
};

export type SiteDetailsBase = WithVersion<WithOptimisticLock<SiteAddressInfo & {
  id: ID;
  name: string;
  lotStreetDetails: string;
  isInspected: boolean;
  inspectedDate: Date;
  version: number;
  lotNumber: string;
  blockNumber: string;
  suburb: string;
  streetNumber: string;
  street: string;
  postCode: string;
  city: string;
  state: string;
  mapReference: string;
  reference: string;
  etag?: string;
}>>;
export type SiteDetailsDto = SiteDetailsBase & {
  inspections: InspectionItemDto[];
};

export type InspectionItemDto = {
  name: string;
  value: string;
  availableValues: string[];
};

export type SiteListItemDto = WithOptimisticLock<WithVersion<{
  id: ID;
  name: string;
  inspectedDate: Date;
  isInspected: boolean;
  lotStreetDetails: string;
}>>;

export type SiteListDto = {
  salesFolderId: ID;
  customerName: string;
  salesFolderName: string;
  sites: SiteListItemDto[];
};

export const validateSiteAddressInfo = ({
                                          lotNumber, suburb, street, streetNumber,
                                        }: SiteAddressInfo) => {
  if (IS_REGION_US && (
    (isEmpty(lotNumber) || isEmpty(suburb)) &&
    (isEmpty(street) || isEmpty(suburb))
  )
  ) {
    return 'msg_site_details_full_lot_street';
  } else if (IS_REGION_AU_OR_NZ) {
    if (isEmpty(lotNumber) && isEmpty(streetNumber)) {
      return 'msg_site_details_either_lot_street';
    } else if (isEmpty(street) || isEmpty(suburb)) {
      return 'msg_site_details_both_street_suburb';
    }
  }
};
